import { FC } from 'react';
import { ReportingCenter } from 'components/ReportingCenter';
import { Page } from 'layouts/Page';

export const ReportingCenterPage: FC = () => {
	return (
		<Page title="Reporting Center – EAS Control Center">
			<ReportingCenter />
		</Page>
	);
};
